import { Box } from '@mui/material'
import React from 'react'

const ContactMap = () => {
  return (
    <Box
        sx={{
            width: "100%",
            height: "100%",
            
            border: "2px solid #ccc",
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)",
            
        }}
        >
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d83327.56064138685!2d-123.2063044939041!3d49.25770615031816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548673f143a94fb3%3A0xbb9196ea9b81f38b!2sVancouver%2C%20BC!5e0!3m2!1sen!2sca!4v1743032682834!5m2!1sen!2sca"
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="Embedded Page"
            loading='lazy'
        ></iframe>
    </Box>
)}

export default ContactMap